import { render, staticRenderFns } from "./CandidateScreening.vue?vue&type=template&id=64eaaa49&"
import script from "./CandidateScreening.vue?vue&type=script&lang=js&"
export * from "./CandidateScreening.vue?vue&type=script&lang=js&"
import style0 from "./CandidateScreening.vue?vue&type=style&index=0&id=64eaaa49&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports